"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

export function HeaderNavigation() {
    const pathname = usePathname()

    const getNavItemClass = (page: string) => {
        const baseClass = "onest-nav transition-all duration-300 px-3 py-2 rounded-md"
        return pathname === page
            ? `${baseClass} text-gray-900 bg-gray-100 font-semibold`
            : `${baseClass} text-gray-600 hover:text-gray-900 hover:bg-gray-50`
    }

    return (
        <nav className="flex items-center gap-6 xl:gap-8">
            <a
                href="/#how-it-works"
                className="onest-nav text-gray-600 hover:text-gray-900 transition-all duration-300"
            >
                Как это работает
            </a>
            <Link
                href="/functions"
                className={getNavItemClass('/functions')}
            >
                Функционал
            </Link>
            <Link
                href="/usage"
                className={getNavItemClass('/usage')}
            >
                Варианты использования
            </Link>
            <Link
                href="/pricing"
                className={getNavItemClass('/pricing')}
            >
                Цены
            </Link>
        </nav>
    )
}
